export { default as ClinicActions, types as ClinicTypes } from './actions';
export { default as ClinicSagas } from './sagas';
export { default as ClinicReducers } from './reducers';
